import { GET_ID_GEN, INCREMENT_ID_GEN } from 'redux/actionTypes';

export default function idGen(state = [], action) {
    switch(action.type) {
        case GET_ID_GEN:
            return [
                ...state,
                ...action.payload
            ];
        case INCREMENT_ID_GEN:
            const index = state.findIndex(idGen => idGen.info.user === action.payload.user);
            return [
                ...state.slice(0, index),
                {
                    ...state[index],
                    body: {
                        ...state[index].body,
                        [action.payload.field]: state[index].body[action.payload.field] + 1
                    }
                },
                ...state.slice(index + 1)
            ];
        default:
            return state;
    }
};